<template>
  <div class="controls-wrapper">
    <icon-button :icon="icon" @click="handleClick" :fa="isIconFa" />

    <div v-if="hasDialog">
      <el-dialog :append-to-body="true" v-if="showDialog" :title="dialogTitle || null" append-to-body :width="dialogWidth || '450px'" :top="dialogTop || '0vh'" :custom-class="dialogPaddingString" :visible.sync="showDialog">
        <slot v-if="showDialog" :obj="obj" :update="update"></slot>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StationControls',
  props: {
    dialogTitle: String,
    dialogWidth: String,
    dialogTop: String,
    dialogPadding: Boolean,
    icon: String,
    obj: {
      type: Object,
      required: true
    },
    leftControl: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  computed: {
    hasDialog () {
      return !!this.$scopedSlots.default
    },
    isIconFa () {
      const elIcon = this.icon.split('-')[0]
      return elIcon !== undefined && elIcon !== 'el'
    },
    dialogPaddingString () {
      const padding = !this.dialogPadding ? 'dialog-no-padding' : ''
      return padding + ' full-width-mobile'
    }
  },
  methods: {
    handleClick () {
      if (this.hasDialog) {
        this.showDialog = true
      } else {
        this.$emit('action', this.obj)
      }
    },
    update (updated) {
      this.showDialog = false
      this.$emit('update', this.obj, updated)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shared/TableControls.vue